(function () {
  document.documentElement.classList.add('fh-js');

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const brandAttributeNames = ['alt', 'aria-label', 'title', 'placeholder', 'content', 'data-image-alt', 'data-product-title'];
  const legacyTextPattern = /(BELIONE|Belione|belione|SCENIQO|Sceniqo|Semico|semico|Cynico|cynico|Ceniqo|ceniqo|Seniqo|seniqo|contact@belione\.com|contact@sceniqo\.com|contact@gmail\.com|belione\.com|sceniqo\.com|BLISS|Bliss|bliss|Scenigo|Built-In Bra|SleepEase|sleep apnea|snoring|FREE delivery|Free delivery|free delivery|FREE shipping|Free shipping|free shipping)/;
  const legacyReviewNamePattern = /(Michelle R\.|Sarah K\.|Jessica L\.|Elena P\.|Rachel M\.|Sophie T\.|Olivia Clarke)/;
  const reviewNameAttributeNames = ['alt', 'aria-label', 'title'];
  const reviewNameReplacements = {
    'Michelle R.': 'Giulia Romano',
    'Sarah K.': 'Sofia Conti',
    'Jessica L.': 'Chiara Lombardi',
    'Elena P.': 'Elena Ferri',
    'Rachel M.': 'Martina Moretti',
    'Sophie T.': 'Francesca Ricci',
    'Olivia Clarke': 'Alessia Bianchi',
  };

  function normalizeBrandText(text) {
    if (!text || !legacyTextPattern.test(text)) return text;
    return text
      .replace(/\bSCENIGO\b/g, 'BELIONE')
      .replace(/\bScenigo\b/g, 'Belione')
      .replace(/\bscenigo\b/g, 'belione')
      .replace(/\bBELIONE\b/g, 'BELIONE')
      .replace(/\bBelione\b/g, 'Belione')
      .replace(/\bbelione\b/g, 'belione')
      .replace(/\bSCENIQO\b/g, 'BELIONE')
      .replace(/\bSceniqo\b/g, 'Belione')
      .replace(/\bSemico\b/g, 'Belione')
      .replace(/\bsemico\b/g, 'belione')
      .replace(/\bCynico\b/g, 'Belione')
      .replace(/\bcynico\b/g, 'belione')
      .replace(/\bCeniqo\b/g, 'Belione')
      .replace(/\bceniqo\b/g, 'belione')
      .replace(/\bSeniqo\b/g, 'Belione')
      .replace(/\bseniqo\b/g, 'belione')
      .replace(/contact@belione\.com/g, 'contact@belione.com')
      .replace(/contact@sceniqo\.com/g, 'contact@belione.com')
      .replace(/contact@gmail\.com/g, 'contact@belione.com')
      .replace(/https:\/\/belione\.com/g, 'https://belione.com')
      .replace(/http:\/\/belione\.com/g, 'http://belione.com')
      .replace(/www\.belione\.com/g, 'www.belione.com')
      .replace(/belione\.com/g, 'belione.com')
      .replace(/https:\/\/sceniqo\.com/g, 'https://belione.com')
      .replace(/http:\/\/sceniqo\.com/g, 'http://belione.com')
      .replace(/www\.sceniqo\.com/g, 'www.belione.com')
      .replace(/sceniqo\.com/g, 'belione.com')
      .replace(/\bBelione Front-Support Tank Top with Built-In Bra\b/g, 'Belione Front-Support Tank Top with Built-In-Bra')
      .replace(/\bScenigo Front-Support Tank Top with Built-In Bra\b/g, 'Belione Front-Support Tank Top with Built-In-Bra')
      .replace(/\bSleepEase Pro\s*:\s*Eliminates Snoring & Sleep Apnea\b/gi, 'Belione Front-Support Tank Top with Built-In-Bra')
      .replace(/\+\s*FREE delivery\b/gi, 'Tracked delivery')
      .replace(/\bFREE delivery\b/gi, 'Tracked delivery')
      .replace(/\bFree delivery\b/g, 'Tracked delivery')
      .replace(/\bfree delivery\b/g, 'tracked delivery')
      .replace(/\+\s*FREE shipping\b/gi, 'Tracked delivery')
      .replace(/\bFREE shipping\b/gi, 'Tracked delivery')
      .replace(/\bFree shipping\b/g, 'Tracked delivery')
      .replace(/\bfree shipping\b/g, 'tracked delivery')
      .replace(/\bBLISS\s+BLISS\b/g, 'Belione')
      .replace(/\bBLISS\s+Bliss\b/g, 'Belione')
      .replace(/\bBLISS\s+bliss\b/g, 'Belione')
      .replace(/\bBLISS\b/g, 'Belione')
      .replace(/\bBliss\b/g, 'Belione')
      .replace(/\bbliss\b/g, 'Belione');
  }

  function replaceBrandTerms(root = document.body) {
    if (!root) return;
    const textWalker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || parent.closest('script, style, noscript, svg')) return NodeFilter.FILTER_REJECT;
        return legacyTextPattern.test(node.nodeValue || '') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      },
    });

    const textNodes = [];
    while (textWalker.nextNode()) textNodes.push(textWalker.currentNode);
    textNodes.forEach((node) => {
      node.nodeValue = normalizeBrandText(node.nodeValue);
    });

    const attributeSelector = brandAttributeNames
      .map((name) => `[${name}*="BELIONE"], [${name}*="Belione"], [${name}*="belione"], [${name}*="SCENIQO"], [${name}*="Sceniqo"], [${name}*="Semico"], [${name}*="semico"], [${name}*="Cynico"], [${name}*="cynico"], [${name}*="Ceniqo"], [${name}*="ceniqo"], [${name}*="Seniqo"], [${name}*="seniqo"], [${name}*="contact@belione.com"], [${name}*="contact@sceniqo.com"], [${name}*="contact@gmail.com"], [${name}*="belione.com"], [${name}*="sceniqo.com"], [${name}*="BLISS"], [${name}*="Bliss"], [${name}*="bliss"], [${name}*="Scenigo"], [${name}*="SleepEase"], [${name}*="snoring"], [${name}*="sleep apnea"], [${name}*="FREE delivery"], [${name}*="Free delivery"], [${name}*="FREE shipping"], [${name}*="Free shipping"]`)
      .join(',');
    root.querySelectorAll?.(attributeSelector).forEach((element) => {
      brandAttributeNames.forEach((name) => {
        if (element.hasAttribute(name)) element.setAttribute(name, normalizeBrandText(element.getAttribute(name)));
      });
    });
  }

  function normalizeReviewNames(text) {
    if (!text || !legacyReviewNamePattern.test(text)) return text;
    return text.replace(legacyReviewNamePattern, (name) => reviewNameReplacements[name] || name);
  }

  function replaceReviewNames(root = document.body) {
    if (!root) return;
    const textWalker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || parent.closest('script, style, noscript, svg')) return NodeFilter.FILTER_REJECT;
        return legacyReviewNamePattern.test(node.nodeValue || '') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      },
    });

    const textNodes = [];
    while (textWalker.nextNode()) textNodes.push(textWalker.currentNode);
    textNodes.forEach((node) => {
      node.nodeValue = normalizeReviewNames(node.nodeValue);
    });

    const attributeSelector = reviewNameAttributeNames
      .map((name) => `[${name}*="Michelle R."], [${name}*="Sarah K."], [${name}*="Jessica L."], [${name}*="Elena P."], [${name}*="Rachel M."], [${name}*="Sophie T."], [${name}*="Olivia Clarke"]`)
      .join(',');
    root.querySelectorAll?.(attributeSelector).forEach((element) => {
      reviewNameAttributeNames.forEach((name) => {
        if (element.hasAttribute(name)) element.setAttribute(name, normalizeReviewNames(element.getAttribute(name)));
      });
    });
  }

  replaceBrandTerms();
  replaceReviewNames();
  document.addEventListener('shopify:section:load', (event) => {
    replaceBrandTerms(event.target);
    replaceReviewNames(event.target);
  });

  function removeLoopCloneAttributes(element) {
    Array.from(element.attributes).forEach((attribute) => {
      if (attribute.name === 'id' || attribute.name.startsWith('data-shopify')) {
        element.removeAttribute(attribute.name);
      }
    });
    element.querySelectorAll('[id], [data-shopify]').forEach(removeLoopCloneAttributes);
  }

  function keepSocialProofMoving(root = document) {
    if (!document.getElementById('fh-social-proof-motion-override')) {
      const style = document.createElement('style');
      style.id = 'fh-social-proof-motion-override';
      style.textContent = '.fh-social-proof__track{animation-play-state:running!important}';
      document.head.appendChild(style);
    }

    const carousels = [];
    if (root.matches?.('.fh-social-proof')) carousels.push(root);
    root.querySelectorAll?.('.fh-social-proof').forEach((carousel) => carousels.push(carousel));

    carousels.forEach((carousel) => {
      const track = carousel.querySelector('[data-fh-social-proof-track], .fh-social-proof__track');
      if (!track) return;

      track.querySelectorAll('[data-fh-social-proof-clone], .fh-social-proof-card[aria-hidden="true"]').forEach((clone) => clone.remove());

      let cards = Array.from(track.querySelectorAll('[data-fh-social-proof-card]'));
      if (cards.length === 0) {
        cards = Array.from(track.querySelectorAll('.fh-social-proof-card'));
      }
      if (cards.length === 0) return;

      const style = window.getComputedStyle(track);
      const gap = Number.parseFloat(style.columnGap || style.gap) || 0;
      const firstRect = cards[0].getBoundingClientRect();
      const lastRect = cards[cards.length - 1].getBoundingClientRect();
      const distance = Math.max(1, lastRect.right - firstRect.left + gap);
      track.style.setProperty('--fh-social-proof-loop-distance', `${Math.round(distance)}px`);

      let filledWidth = distance;
      let cloneRounds = 0;
      const minimumWidth = distance + window.innerWidth * 2;
      while (filledWidth < minimumWidth && cloneRounds < 10) {
        cards.forEach((card) => {
          const clone = card.cloneNode(true);
          clone.setAttribute('data-fh-social-proof-clone', 'true');
          clone.setAttribute('aria-hidden', 'true');
          removeLoopCloneAttributes(clone);
          track.appendChild(clone);
        });
        filledWidth += distance;
        cloneRounds += 1;
      }

      const configuredSpeed = Number.parseFloat(track.style.getPropertyValue('--fh-social-proof-speed')) || 64;
      track.style.setProperty('animation-duration', `${Math.max(58, configuredSpeed)}s`, 'important');
      track.style.animationPlayState = 'running';
    });
  }

  keepSocialProofMoving();
  window.addEventListener('load', () => keepSocialProofMoving());
  window.addEventListener('resize', () => window.requestAnimationFrame(() => keepSocialProofMoving()));
  document.addEventListener('shopify:section:load', (event) => keepSocialProofMoving(event.target));
  if ('MutationObserver' in window) {
    const brandObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            node.nodeValue = normalizeBrandText(node.nodeValue);
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            replaceBrandTerms(node);
            keepSocialProofMoving(node);
          }
        });
      });
    });
    brandObserver.observe(document.body, { childList: true, subtree: true });
  }

  function setPressedState(element) {
    element.addEventListener('pointerdown', () => element.classList.add('is-pressed'));
    ['pointerup', 'pointerleave', 'blur'].forEach((eventName) => {
      element.addEventListener(eventName, () => element.classList.remove('is-pressed'));
    });
  }

  document.querySelectorAll('.fh-button, .fh-icon-button, .fh-colour-choice').forEach(setPressedState);

  function syncHeaderOffset() {
    const headerGroup = document.getElementById('header-group');
    const header = headerGroup?.querySelector('.fh-header');
    if (!headerGroup || !header) return;
    document.documentElement.style.setProperty('--fh-header-offset', `${Math.ceil(headerGroup.getBoundingClientRect().height)}px`);
  }

  function syncHeaderScrollState() {
    const header = document.querySelector('#header-group .fh-header');
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 8);
  }

  syncHeaderOffset();
  syncHeaderScrollState();
  window.addEventListener('resize', syncHeaderOffset);
  window.addEventListener('scroll', syncHeaderScrollState, { passive: true });
  document.addEventListener('shopify:section:load', syncHeaderOffset);
  document.addEventListener('shopify:section:load', syncHeaderScrollState);

  document.querySelectorAll('[data-fh-menu-toggle]').forEach((toggle) => {
    const panelId = toggle.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : document.querySelector('[data-fh-mobile-panel]');
    if (!panel) return;

    const closeButtons = panel.querySelectorAll('[data-fh-close-menu], nav a');
    const firstFocusable = () => panel.querySelector(focusableSelector);

    function openMenu() {
      panel.classList.add('is-open');
      document.body.classList.add('fh-menu-open');
      toggle.setAttribute('aria-expanded', 'true');
      window.setTimeout(() => firstFocusable()?.focus(), reduceMotion ? 0 : 120);
    }

    function closeMenu() {
      panel.classList.remove('is-open');
      document.body.classList.remove('fh-menu-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus();
    }

    toggle.addEventListener('click', () => {
      if (panel.classList.contains('is-open')) closeMenu();
      else openMenu();
    });

    closeButtons.forEach((item) => item.addEventListener('click', closeMenu));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && panel.classList.contains('is-open')) closeMenu();
    });
  });

  document.querySelectorAll('[data-fh-gallery]').forEach((gallery) => {
    const stage = gallery.querySelector('[data-fh-stage]');
    const thumbTrack = gallery.querySelector('[data-fh-thumb-track]');
    const thumbNavPrev = gallery.querySelector('[data-fh-thumb-nav="prev"]');
    const thumbNavNext = gallery.querySelector('[data-fh-thumb-nav="next"]');

    if (stage) {
      gallery.querySelectorAll('[data-fh-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const img = thumb.querySelector('img');
          const placeholderLabel = thumb.dataset.fhPlaceholderLabel || 'Image placeholder';
          const isVideo = thumb.dataset.fhMediaType === 'video' && thumb.dataset.fhVideoSrc;

          if (isVideo) {
            const video = document.createElement('video');
            video.className = 'fh-gallery-video';
            video.src = thumb.dataset.fhVideoSrc;
            video.muted = true;
            video.loop = true;
            video.autoplay = true;
            video.playsInline = true;
            video.preload = 'auto';
            video.setAttribute('muted', '');
            video.setAttribute('loop', '');
            video.setAttribute('autoplay', '');
            video.setAttribute('playsinline', '');
            video.setAttribute('aria-label', thumb.dataset.fhVideoAlt || 'Product video');
            stage.replaceChildren(video);
            const playPromise = video.play();
            if (playPromise) playPromise.catch(() => {});
          } else if (img && thumb.dataset.fhSrc) {
            const nextImage = document.createElement('img');
            nextImage.src = thumb.dataset.fhSrc;
            nextImage.alt = img.alt || '';
            nextImage.loading = 'eager';
            stage.replaceChildren(nextImage);
          } else {
            stage.innerHTML = `<div class="fh-placeholder-media" role="img" aria-label="${placeholderLabel}"><span>${placeholderLabel}</span></div>`;
          }
          gallery.querySelectorAll('[data-fh-thumb]').forEach((other) => other.setAttribute('aria-current', 'false'));
          thumb.setAttribute('aria-current', 'true');
        });
      });
    }

    if (thumbTrack && (thumbNavPrev || thumbNavNext)) {
      const navThreshold = 2;
      let pendingThumbNavUpdate = false;

      function updateThumbNav() {
        pendingThumbNavUpdate = false;
        const maxScroll = Math.max(0, thumbTrack.scrollHeight - thumbTrack.clientHeight);
        gallery.classList.toggle('has-thumbs-prev', thumbTrack.scrollTop > navThreshold);
        gallery.classList.toggle('has-thumbs-next', maxScroll > navThreshold && thumbTrack.scrollTop < maxScroll - navThreshold);
      }

      function requestThumbNavUpdate() {
        if (pendingThumbNavUpdate) return;
        pendingThumbNavUpdate = true;
        window.requestAnimationFrame(updateThumbNav);
      }

      function scrollThumbs(direction) {
        const maxScroll = Math.max(0, thumbTrack.scrollHeight - thumbTrack.clientHeight);
        thumbTrack.scrollTo({ top: direction > 0 ? maxScroll : 0, behavior: reduceMotion ? 'auto' : 'smooth' });
        gallery.classList.toggle('has-thumbs-prev', direction > 0 && maxScroll > navThreshold);
        gallery.classList.toggle('has-thumbs-next', direction < 0 && maxScroll > navThreshold);
        window.setTimeout(updateThumbNav, reduceMotion ? 0 : 420);
      }

      thumbNavPrev?.addEventListener('click', () => scrollThumbs(-1));
      thumbNavNext?.addEventListener('click', () => scrollThumbs(1));
      thumbTrack.addEventListener('scroll', requestThumbNavUpdate, { passive: true });
      window.addEventListener('resize', requestThumbNavUpdate);
      window.setTimeout(updateThumbNav, 0);
      window.setTimeout(updateThumbNav, 300);
    }

    const mobileTrack = gallery.querySelector('[data-fh-mobile-track]');
    const mobileSlides = mobileTrack ? Array.from(mobileTrack.querySelectorAll('[data-fh-mobile-slide]')) : [];
    const mobileDots = Array.from(gallery.querySelectorAll('[data-fh-mobile-dot]'));

    if (mobileTrack && mobileSlides.length > 1 && mobileDots.length > 1) {
      let pendingDotUpdate = false;

      function setActiveDot(index) {
        mobileDots.forEach((dot, dotIndex) => {
          dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
        });
      }

      function updateActiveDot() {
        pendingDotUpdate = false;
        const trackLeft = mobileTrack.scrollLeft;
        let activeIndex = 0;
        let closestDistance = Infinity;

        mobileSlides.forEach((slide, index) => {
          const distance = Math.abs(slide.offsetLeft - mobileTrack.offsetLeft - trackLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            activeIndex = index;
          }
        });

        setActiveDot(activeIndex);
      }

      mobileDots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = Number.parseInt(dot.dataset.fhMobileIndex || '0', 10);
          const slide = mobileSlides[index];
          if (!slide) return;
          mobileTrack.scrollTo({ left: slide.offsetLeft - mobileTrack.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
          setActiveDot(index);
        });
      });

      mobileTrack.addEventListener('scroll', () => {
        if (pendingDotUpdate) return;
        pendingDotUpdate = true;
        window.requestAnimationFrame(updateActiveDot);
      }, { passive: true });

      window.addEventListener('resize', updateActiveDot);
      setActiveDot(0);
    }
  });

  document.querySelectorAll('[data-fh-product]').forEach((root) => {
    const variantSelect = root.querySelector('[data-fh-variant-select]');
    const selectedColour = root.querySelector('[data-fh-selected-colour]');
    const stickyId = root.querySelector('[data-fh-sticky-variant]');
    const stage = root.querySelector('[data-fh-stage]');
    const submitButtons = root.querySelectorAll('[data-fh-submit], [data-fh-sticky-submit]');
    const sticky = root.querySelector('[data-fh-sticky-atc], .fh-sticky-atc');

    function updatePrice(target, option) {
      if (!target || !option) return;
      const sale = target.querySelector('[data-fh-price-sale]');
      const compare = target.querySelector('[data-fh-price-compare]');
      const saving = target.querySelector('[data-fh-price-saving]');
      const badge = target.querySelector('[data-fh-price-badge]');

      if (sale) sale.textContent = option.dataset.price || '';
      if (compare) {
        compare.textContent = option.dataset.compare || '';
        compare.hidden = option.dataset.hasSaving !== 'true';
        compare.classList.toggle('hidden', option.dataset.hasSaving !== 'true');
      }
      if (saving) {
        saving.textContent = option.dataset.saving || '';
        saving.hidden = option.dataset.hasSaving !== 'true';
        saving.classList.toggle('hidden', option.dataset.hasSaving !== 'true');
      }
      if (badge) {
        badge.hidden = option.dataset.hasSaving !== 'true';
        badge.classList.toggle('hidden', option.dataset.hasSaving !== 'true');
      }
    }

    function syncVariant() {
      if (!variantSelect) return;
      const option = variantSelect.options[variantSelect.selectedIndex];
      if (!option) return;

      root.querySelectorAll('[data-fh-price-root]').forEach((priceRoot) => updatePrice(priceRoot, option));
      if (stickyId) stickyId.value = option.value;

      const available = option.dataset.available !== 'false';
      submitButtons.forEach((button) => {
        button.disabled = !available;
        if (button.dataset.availableLabel && button.dataset.soldOutLabel) {
          button.textContent = available ? button.dataset.availableLabel : button.dataset.soldOutLabel;
        }
      });

      if (selectedColour && option.dataset.colourName) selectedColour.textContent = option.dataset.colourName;
      const usesAssetGallery = Boolean(root.querySelector('.fh-product-gallery--assets'));
      if (stage && option.dataset.image && !usesAssetGallery) {
        stage.innerHTML = `<img src="${option.dataset.image}" alt="${option.dataset.imageAlt || option.dataset.title || ''}" loading="eager">`;
      }

      root.querySelectorAll('[data-fh-colour]').forEach((choice) => {
        if (!choice.dataset.variantId) return;
        const isCurrent = choice.dataset.variantId === option.value;
        choice.classList.toggle('is-selected', isCurrent);
        choice.setAttribute('aria-checked', isCurrent ? 'true' : 'false');
      });
    }

    if (variantSelect) {
      variantSelect.addEventListener('change', syncVariant);
      syncVariant();
    }

    root.querySelectorAll('[data-fh-colour]').forEach((choice) => {
      choice.addEventListener('click', () => {
        if (choice.getAttribute('aria-disabled') === 'true') return;
        const input = choice.querySelector('input[type="radio"]');
        if (input) input.checked = true;
        if (variantSelect && choice.dataset.variantId) {
          variantSelect.value = choice.dataset.variantId;
          variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
        const group = choice.closest('[data-fh-colour-picker]');
        if (group) {
          group.querySelectorAll('[data-fh-colour]').forEach((other) => {
            const isCurrent = other === choice;
            other.classList.toggle('is-selected', isCurrent);
            other.setAttribute('aria-checked', isCurrent ? 'true' : 'false');
          });
        }
        if (selectedColour && choice.dataset.colourName) selectedColour.textContent = choice.dataset.colourName;
      });
    });

    if (sticky) {
      const stickyBlockingSections = document.querySelectorAll('[data-fh-blur-banner], .fh-testimonial-carousel, .fh-comparison-showcase');
      const footer = document.querySelector('.fh-footer');
      const heroBottom = () => root.getBoundingClientRect().bottom + window.scrollY - 120;
      const blockingSectionIsVisible = () => {
        return Array.from(stickyBlockingSections).some((section) => {
          const rect = section.getBoundingClientRect();
          return rect.top < window.innerHeight * 0.9 && rect.bottom > window.innerHeight * 0.12;
        });
      };
      const footerIsNear = () => {
        if (!footer) return false;
        return footer.getBoundingClientRect().top < window.innerHeight - 20;
      };
      function updateSticky() {
        const shouldShowSticky = window.scrollY > heroBottom() && !blockingSectionIsVisible() && !footerIsNear();
        sticky.classList.toggle('is-visible', shouldShowSticky);
        document.body.classList.toggle('fh-has-sticky-atc', shouldShowSticky);
      }
      updateSticky();
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky);
    }
  });

  document.querySelectorAll('[data-fh-qty]').forEach((quantity) => {
    const input = quantity.querySelector('input');
    quantity.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        if (!input) return;
        const current = Number.parseInt(input.value || '1', 10);
        const next = button.dataset.action === 'minus' ? Math.max(1, current - 1) : current + 1;
        input.value = String(next);
      });
    });
  });

  document.querySelectorAll('[data-fh-blur-banner]').forEach((banner) => {
    const hero = banner.querySelector('[data-fh-blur-hero]');
    if (!hero) return;

    let pending = false;
    function updateBlur() {
      pending = false;
      const bannerRect = banner.getBoundingClientRect();
      const heroStyles = window.getComputedStyle(hero);
      const stickyTop = Number.parseFloat(heroStyles.getPropertyValue('--fh-immersive-sticky-top')) || 0;
      const travelDistance = Math.max(1, bannerRect.height - window.innerHeight);
      const progress = Math.min(1, Math.max(0, (stickyTop - bannerRect.top) / travelDistance));
      const blurProgress = Math.min(1, Math.max(0, (progress - 0.08) / 0.36));
      const shouldPin = bannerRect.top <= stickyTop && bannerRect.bottom > window.innerHeight;
      const shouldRelease = bannerRect.bottom <= window.innerHeight;

      hero.classList.toggle('is-pinned', shouldPin);
      hero.classList.toggle('is-released', shouldRelease);
      hero.classList.toggle('is-filtered', blurProgress > 0.04);
      hero.style.setProperty('--fh-blur-opacity', (0.08 + blurProgress * 0.44).toFixed(3));
      hero.style.setProperty('--fh-blur-amount', `${Math.round(blurProgress * 14)}px`);
    }
    function requestUpdate() {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(updateBlur);
    }

    updateBlur();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  });

  document.querySelectorAll('.fh-testimonial-carousel').forEach((carousel) => {
    const track = carousel.querySelector('[data-fh-review-track]');
    const originalCards = track ? Array.from(track.querySelectorAll('[data-fh-review-card]')) : [];
    let resizeFrame = null;

    function removeEditorAttributes(element) {
      Array.from(element.attributes).forEach((attribute) => {
        if (attribute.name === 'id' || attribute.name.startsWith('data-shopify')) {
          element.removeAttribute(attribute.name);
        }
      });
      element.querySelectorAll('[id], [data-shopify]').forEach(removeEditorAttributes);
    }

    function measureLoop() {
      if (!track || originalCards.length === 0) return;
      track.querySelectorAll('[data-fh-review-clone]').forEach((clone) => clone.remove());

      const style = window.getComputedStyle(track);
      const gap = Number.parseFloat(style.columnGap || style.gap) || 0;
      const firstRect = originalCards[0].getBoundingClientRect();
      const lastRect = originalCards[originalCards.length - 1].getBoundingClientRect();
      const distance = Math.max(1, lastRect.right - firstRect.left + gap);
      track.style.setProperty('--fh-review-loop-distance', `${Math.round(distance)}px`);

      let filledWidth = distance;
      let cloneRounds = 0;
      const minimumWidth = distance + window.innerWidth * 2;
      while (filledWidth < minimumWidth && cloneRounds < 8) {
        originalCards.forEach((card) => {
          const clone = card.cloneNode(true);
          clone.setAttribute('data-fh-review-clone', 'true');
          clone.setAttribute('aria-hidden', 'true');
          removeEditorAttributes(clone);
          track.appendChild(clone);
        });
        filledWidth += distance;
        cloneRounds += 1;
      }
    }

    measureLoop();
    window.addEventListener('resize', () => {
      if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
      resizeFrame = window.requestAnimationFrame(measureLoop);
    });

    if (reduceMotion || !('IntersectionObserver' in window)) {
      carousel.classList.add('is-rolling');
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        carousel.classList.toggle('is-rolling', entry.isIntersecting);
      });
    }, { rootMargin: '0px 0px -18% 0px', threshold: 0.16 });

    observer.observe(carousel);
  });

  document.querySelectorAll('.fh-accordion details, .fh-faq details').forEach((details) => {
    const summary = details.querySelector('summary');
    const answer = details.querySelector('.fh-answer');
    if (!summary) return;
    summary.setAttribute('aria-expanded', String(details.open));
    if (answer && !reduceMotion) answer.style.maxHeight = details.open ? `${answer.scrollHeight}px` : '0px';

    details.addEventListener('toggle', () => {
      summary.setAttribute('aria-expanded', String(details.open));
      if (!answer || reduceMotion) return;
      answer.style.overflow = 'hidden';
      answer.style.transition = 'max-height 260ms cubic-bezier(.2,.65,.25,1)';
      answer.style.maxHeight = details.open ? `${answer.scrollHeight}px` : '0px';
    });
  });

  function getCountUpParts(value) {
    const text = String(value || '').trim();
    const match = text.match(/-?\d[\d,.]*/);
    if (!match) return null;

    const rawNumber = match[0];
    const prefix = text.slice(0, match.index);
    const suffix = text.slice(match.index + rawNumber.length);
    const hasDotDecimal = rawNumber.includes('.');
    const hasCommaDecimal = rawNumber.includes(',') && !hasDotDecimal && !/,\d{3}(\D|$)/.test(rawNumber);
    const decimalPlaces = hasDotDecimal
      ? (rawNumber.split('.')[1] || '').length
      : hasCommaDecimal
        ? (rawNumber.split(',')[1] || '').length
        : 0;
    const normalizedNumber = hasCommaDecimal
      ? rawNumber.replace(',', '.')
      : rawNumber.replace(/,/g, '');
    const target = Number.parseFloat(normalizedNumber);

    if (!Number.isFinite(target)) return null;
    return { prefix, suffix, target, decimalPlaces, original: text };
  }

  function formatCountUpValue(value, decimalPlaces) {
    return new Intl.NumberFormat('en-GB', {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces,
    }).format(value);
  }

  function initCountUps(root = document) {
    const values = root.querySelectorAll?.('[data-fh-count-up]') || [];
    values.forEach((element) => {
      if (element.dataset.fhCountBound === 'true') return;
      const parts = getCountUpParts(element.textContent);
      if (!parts) return;

      element.dataset.fhCountBound = 'true';
      element.dataset.fhCountOriginal = parts.original;

      const renderValue = (value) => {
        element.textContent = `${parts.prefix}${formatCountUpValue(value, parts.decimalPlaces)}${parts.suffix}`;
      };

      if (reduceMotion || !('IntersectionObserver' in window)) {
        element.textContent = parts.original;
        return;
      }

      renderValue(0);

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const startTime = performance.now();
          const duration = 1300;
          const animate = (now) => {
            const progress = Math.min(1, (now - startTime) / duration);
            const easedProgress = 1 - Math.pow(1 - progress, 3);
            const currentValue = parts.target * easedProgress;
            renderValue(currentValue);

            if (progress < 1) {
              window.requestAnimationFrame(animate);
            } else {
              element.textContent = parts.original;
            }
          };

          window.requestAnimationFrame(animate);
          observer.unobserve(element);
        });
      }, { rootMargin: '0px 0px -18% 0px', threshold: 0.24 });

      observer.observe(element);
    });
  }

  initCountUps();
  document.addEventListener('shopify:section:load', (event) => initCountUps(event.target));

  function initNewsletterPopup() {
    const popup = document.querySelector('[data-sceniqo-newsletter-popup]');
    if (!popup || popup.dataset.sceniqoNewsletterPopupReady === 'true') return;

    if (window.location.pathname === '/challenge') {
      popup.hidden = true;
      document.body.classList.remove('sceniqo-newsletter-popup-open');
      document.documentElement.classList.remove('sceniqo-newsletter-popup-open');
      return;
    }

    const closeButtons = popup.querySelectorAll('[data-sceniqo-newsletter-popup-close]');
    const form = popup.querySelector('form');
    const firstInput = popup.querySelector('input[type="email"]');
    const storageKey = 'belioneNewsletterPopupSubmitted';
    const pendingKey = 'belioneNewsletterPopupPending';

    function showNewsletterSuccess() {
      if (!form) return;
      const fields = form.querySelector('[data-sceniqo-newsletter-popup-fields]');
      const success = form.querySelector('[data-sceniqo-newsletter-popup-success]');
      const loading = form.querySelector('[data-sceniqo-newsletter-popup-loading]');

      form.classList.remove('is-loading');
      if (loading) loading.hidden = true;
      if (fields) fields.hidden = true;
      if (success) success.hidden = false;
    }

    function setNewsletterFormValues() {
      if (!form) return;

      const formTypeInput = form.querySelector('input[name="form_type"]');
      const utf8Input = form.querySelector('input[name="utf8"]');
      const idInput = form.querySelector('input[name="contact[id]"]');
      const tagsInput = form.querySelector('input[name="contact[tags]"]');
      const marketingInput = form.querySelector('input[name="contact[accepts_marketing]"]');

      if (formTypeInput) formTypeInput.value = 'customer';
      if (utf8Input) utf8Input.value = '✓';
      if (idInput) idInput.value = 'BelioneNewsletterPopupForm';
      if (tagsInput) tagsInput.value = 'newsletter,popup-50,CONFIDENT20';
      if (marketingInput) marketingInput.value = 'true';
    }

    setNewsletterFormValues();
    form?.addEventListener('pointerdown', setNewsletterFormValues, true);
    form?.addEventListener('click', setNewsletterFormValues, true);
    form?.addEventListener('submit', setNewsletterFormValues, true);
    form?.addEventListener('submit', () => {
      try {
        window.sessionStorage.setItem(pendingKey, 'true');
      } catch (error) {
        // Storage can be unavailable; the native Shopify submit will continue.
      }
    }, true);
    form?.addEventListener('formdata', (event) => {
      event.formData.set('form_type', 'customer');
      event.formData.set('utf8', '✓');
      event.formData.set('contact[id]', 'BelioneNewsletterPopupForm');
      event.formData.set('contact[tags]', 'newsletter,popup-50,CONFIDENT20');
      event.formData.set('contact[accepts_marketing]', 'true');
    });

    const hasSubmitted = (() => {
      try {
        return window.sessionStorage.getItem(storageKey) === 'true' || window.localStorage.getItem(storageKey) === 'true';
      } catch (error) {
        return false;
      }
    })();
    const hasAmbassadorSubmitted = (() => {
      try {
        return window.sessionStorage.getItem('belioneAmbassadorFormSubmitted') === 'true';
      } catch (error) {
        return false;
      }
    })();
    const hasNewsletterPending = (() => {
      try {
        return window.sessionStorage.getItem(pendingKey) === 'true';
      } catch (error) {
        return false;
      }
    })();

    const searchParams = new URLSearchParams(window.location.search);
    const hasCustomerPosted = searchParams.get('customer_posted') === 'true';
    const forcePopup = window.Shopify?.designMode === true || searchParams.has('oseid') || searchParams.has('popup_force');
    const isNewsletterPopupSubmission = window.location.hash === '#BelioneNewsletterPopupForm';
    const isAmbassadorSubmission = window.location.hash === '#BelioneAmbassadorForm';
    if (!forcePopup && (hasAmbassadorSubmitted || (hasCustomerPosted && !hasNewsletterPending))) {
      try {
        window.sessionStorage.removeItem('belioneAmbassadorFormSubmitted');
      } catch (error) {
        // Ignore storage cleanup errors.
      }
      popup.hidden = true;
      document.body.classList.remove('sceniqo-newsletter-popup-open');
      document.documentElement.classList.remove('sceniqo-newsletter-popup-open');
      return;
    }

    if (hasCustomerPosted && hasNewsletterPending) {
      try {
        window.sessionStorage.setItem(storageKey, 'true');
        window.localStorage.setItem(storageKey, 'true');
        window.sessionStorage.removeItem(pendingKey);
      } catch (error) {
        // Storage can be unavailable in private browsing; the form has still posted.
      }
      showNewsletterSuccess();
    }

    function openPopup() {
      popup.hidden = false;
      document.body.classList.add('sceniqo-newsletter-popup-open');
      document.documentElement.classList.add('sceniqo-newsletter-popup-open');
      window.requestAnimationFrame(() => {
        popup.classList.add('is-open');
        if (!reduceMotion) window.setTimeout(() => firstInput?.focus({ preventScroll: true }), 520);
      });
    }

    function closePopup() {
      popup.classList.remove('is-open');
      document.body.classList.remove('sceniqo-newsletter-popup-open');
      document.documentElement.classList.remove('sceniqo-newsletter-popup-open');
      window.setTimeout(() => {
        popup.hidden = true;
      }, reduceMotion ? 0 : 540);
    }

    popup.dataset.sceniqoNewsletterPopupReady = 'true';
    closeButtons.forEach((button) => button.addEventListener('click', closePopup));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
    });

    if (hasCustomerPosted && isNewsletterPopupSubmission) {
      openPopup();
      return;
    }

    if (
      !forcePopup && (
        hasSubmitted ||
        window.location.hash === '#newsletter' ||
        window.location.hash === '#BelioneNewsletterPopupForm'
      )
    ) {
      return;
    }

    window.setTimeout(openPopup, reduceMotion ? 250 : 1200);
  }

  initNewsletterPopup();
  document.addEventListener('shopify:section:load', initNewsletterPopup);

  const revealTargets = document.querySelectorAll('[data-fh-reveal], [data-fh-stagger]');
  if (reduceMotion || !('IntersectionObserver' in window)) {
    revealTargets.forEach((element) => element.classList.add('is-visible'));
  } else {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    revealTargets.forEach((element) => observer.observe(element));
  }
})();
